import { Instagram, Linkedin, Twitter, Facebook, MapPin, Mail } from "lucide-react";
import Logo from "./Logo";

const QUICK_LINKS = [
    { label: "Home", href: "#home" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "Services", href: "#services" },
    { label: "About", href: "#about" },
    { label: "Early Access", href: "#early-access" },
];

const SOCIALS = [
    { icon: Instagram, label: "Instagram", testid: "footer-social-instagram" },
    { icon: Linkedin, label: "LinkedIn", testid: "footer-social-linkedin" },
    { icon: Twitter, label: "X (Twitter)", testid: "footer-social-x" },
    { icon: Facebook, label: "Facebook", testid: "footer-social-facebook" },
];

const Footer = () => {
    const go = (e, href) => {
        e.preventDefault();
        document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <footer id="contact" className="bg-white border-t border-slate-100" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-14 sm:py-20">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <a href="#home" onClick={(e) => go(e, "#home")} data-testid="footer-logo" aria-label="Sevano home">
                            <Logo size="lg" />
                        </a>
                        <p className="mt-5 text-sm sm:text-base text-slate-600 leading-relaxed max-w-sm">
                            Reliable household help, whenever you need it. Launching soon in Agartala, Tripura —
                            simple for customers, dependable in the real world.
                        </p>
                        <div className="mt-6 flex gap-3">
                            {SOCIALS.map(({ icon: Icon, label, testid }) => (
                                <a
                                    key={label}
                                    href="#"
                                    onClick={(e) => e.preventDefault()}
                                    aria-label={`${label} (coming soon)`}
                                    data-testid={testid}
                                    className="w-10 h-10 rounded-full border border-slate-200 flex items-center justify-center text-slate-500 transition-all duration-200 hover:border-[#0B5CF5] hover:text-[#0B5CF5] hover:-translate-y-0.5"
                                >
                                    <Icon size={17} />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-5">Explore</h4>
                        <ul className="space-y-3">
                            {QUICK_LINKS.map((l) => (
                                <li key={l.label}>
                                    <a
                                        href={l.href}
                                        onClick={(e) => go(e, l.href)}
                                        className="text-sm font-semibold text-slate-600 hover:text-[#0B5CF5] transition-colors"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-5">Contact</h4>
                        <ul className="space-y-3 text-sm text-slate-600">
                            <li className="flex items-center gap-2.5">
                                <MapPin size={15} className="text-[#0B5CF5] shrink-0" /> Agartala, Tripura 799001
                            </li>
                            <li className="flex items-center gap-2.5">
                                <Mail size={15} className="text-[#0B5CF5] shrink-0" />
                                <a href="mailto:hello@sevano.in" className="hover:text-[#0B5CF5] transition-colors">
                                    hello@sevano.in
                                </a>
                            </li>
                        </ul>
                        <div className="mt-8 flex gap-5">
                            <a
                                href="/privacy"
                                data-testid="footer-privacy-link"
                                className="text-xs font-semibold text-slate-500 hover:text-[#0B5CF5] transition-colors"
                            >
                                Privacy Policy
                            </a>
                            <a
                                href="/terms"
                                data-testid="footer-terms-link"
                                className="text-xs font-semibold text-slate-500 hover:text-[#0B5CF5] transition-colors"
                            >
                                Terms &amp; Conditions
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-slate-400">© 2026 Sevano. All rights reserved.</p>
                    <p className="text-xs text-slate-400">Same home. Less hassle.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
